module.exports = __webpack_public_path__ + "static/media/tampa-bay-web-developer-logo-w-text.d2f67222.jpg";